module.exports = __webpack_public_path__ + "static/media/4.750b266d.svg";